/* eslint-disable no-console */

let registration;

function init() {
  if (!navigator.serviceWorker) {
    return Promise.reject('Service worker not supported');
  }

  navigator.serviceWorker.ready
    .then(() => {
      console.log('service worker registered');
    })
    .catch(function(error) {
      console.log('error when registering service worker', error, arguments);
    });

  return navigator.serviceWorker.register('/service-worker-cache-images.js').then(reg => {
    registration = reg;
    console.log('registration');
    registration.update();
    return registration;
  });
}

let _promise;

export default () => {
  if (registration) return Promise.resolve(registration);

  return _promise ?? (_promise = init());
};
